import { useAuthStore } from '@/store/authStore'
import { PLANS } from '@/utils/plans'
import { Plan } from '@/types'

export function usePlanGuard() {
    const { currentOrg } = useAuthStore()
    const planId = (currentOrg?.plan || 'lite') as Plan
    const planDetails = PLANS[planId] || PLANS['lite']
    const limits = planDetails.limits

    const canUsePix = () => limits.pix

    const checkSpaceLimit = (currentCount: number) => {
        if (limits.spaces === 'unlimited') return true
        return currentCount < limits.spaces
    }

    const getMaxPhotos = () => limits.photosPerSpace

    return {
        plan: planId,
        limits,
        canUsePix,
        checkSpaceLimit,
        getMaxPhotos,
    }
}
